<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
import CardSkeleton from '~/components/skeletons/CardSkeleton.vue'
</script>

<template>
  <AuSkeletonWrapper>
    <div class="mb-12 flex w-full flex-col gap-5 rounded-2xl p-12">
      <AuSkeleton
        width="40%"
        height="30px"
      />
      <div>
        <AuSkeleton
          width="60%"
          height="10px"
        />
        <AuSkeleton
          width="50%"
          height="10px"
        />
      </div>
      <div class="flex flex-1 gap-4">
        <CardSkeleton v-for="i in 4" :key="i" />
      </div>
    </div>
    <div class="border-seagreen-10 mb-12 h-[300px] w-full gap-5 rounded-2xl border-2">
      <div class="flex h-full w-full">
        <AuSkeleton
          width="48.5%"
          height="100%"
        />
        <div class="flex w-1/2 flex-col justify-center gap-7 bg-white p-6 transition-colors sm:p-10">
          <AuSkeleton
            width="20%"
            height="15px"
          />
          <AuSkeleton
            width="70%"
            height="30px"
          />
          <div>
            <AuSkeleton
              width="80%"
              height="10px"
            />
            <AuSkeleton
              width="50%"
              height="10px"
            />
          </div>
        </div>
      </div>
    </div>
  </AuSkeletonWrapper>
</template>
